import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { ItemSelectableWithOptions } from '../../ItemSelectable/ItemSelectableWithOptions';
import { t } from 'i18next';
import BuildingsManagementContext from '../../../context/BuildingManagementContext/BuildingsManagementContext';
import { getTenantInfoByKey } from '../../../helpers/helpers';

export const ListOfBuildings = ({ building, openWarningModalToDelete }) => {
    const navigate = useNavigate();
    const buildingName = getTenantInfoByKey('building_name');

    const { setBuildingData } = useContext(BuildingsManagementContext);

    const goToEditBuilding = async () => {
        await setBuildingData(building);
        navigate(`/settings/entityManagment/buildingsMaganagement/edit/${building.buildingId}`);
    }

    const optionsOfBuilding = [
        {
            name: `${t('EDIT')} ${buildingName}`,
            icon: 'edit-black-icon.svg',
            onClick: () => goToEditBuilding(building),
        },
        {
            name: `${t('DELETE')} ${buildingName}`,
            icon: 'trash-bin.svg',
            onClick: () => openWarningModalToDelete(building),
        },
    ]

    return (
        <>
            <ItemSelectableWithOptions options={optionsOfBuilding} idPopover={`buildingEdit-${building.buildingId}`}>
                <div>
                    <p className='m-0 param-section-title'>{`${building.buildingCode} - ${building.buildingDescription}`}</p>
                    <p className='m-0 mt-1 param-section-subtitle'>{building.Opening ? building.Opening.description : '-'}</p>
                </div>
            </ItemSelectableWithOptions>
        </>

    )
}
